import { User } from '@groma-dev/scaffold';
import { Account, BankAccount } from '../models';
import { AppConfig } from '../AppConfig';

export const ScaffoldClientHeaders = {
  'Content-Type': `vnd.groma.${AppConfig.Settings.Server.apiVersion}+json`,
  Accept: `vnd.groma.${AppConfig.Settings.Server.apiVersion}+json`,
};

export interface AppState {
  initialized: boolean;
  nonREITAccount: boolean;
}

export interface UserStateInterface {
  fetchingUser: boolean;
  user?: User;
}

export interface AccountsStateInterface {
  accounts?: Account[];
  isFetching: boolean;
}

export interface AccountStateInterface {
  account?: Account;
  isFetching: boolean;
  bankAccount?: BankAccount | null;
  isBankAccountFetching: boolean;
}

export interface GromaCoinStateInterface {
  isFetching: boolean;
}

export interface AccountHoldingsStateInterface {
  isFetching: boolean;
}

export interface WalletBalanceStateInterface {
  isFetching: boolean;
}

export interface AccountDocumentsFetchingStateInterface {
  // dynamically set keys based on category and fetching state is value
  [key: string]: boolean;
}

export interface AccountTransactionsInterface {
  isFetching: boolean;
}

export interface BankAccountStateInterface {
  isFetching: boolean;
}
